"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StationStatus = void 0;
const react_1 = __importDefault(require("react"));
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const StationStatus = ({ location }) => {
    const { translate } = (0, i18n_1.useI18n)();
    const siteStatus = location.site_status;
    if (siteStatus === "Active" || !siteStatus)
        return null;
    const siteStatusKey = siteStatus.replace(" ", "_").toLowerCase();
    return (react_1.default.createElement("div", { "aria-role": "alert", className: "location-page__status" }, translate(`station_page.site_status.${siteStatusKey}`)));
};
exports.StationStatus = StationStatus;
